var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1146 7.79068V22.184C22.1146 22.7507 21.9446 23.3032 21.6329 23.7707L17.7654 29.5223C17.1563 30.4432 15.6404 31.0948 14.3513 30.6132C12.9629 30.1457 12.0421 28.5873 12.3396 27.199L13.0763 22.5665C13.1329 22.1415 13.0196 21.759 12.7788 21.4615C12.5379 21.1923 12.1838 21.0223 11.8013 21.0223H5.97876C4.8596 21.0223 3.89626 20.569 3.3296 19.7757C2.79126 19.0107 2.6921 18.019 3.04626 17.0132L6.53126 6.40234C6.97043 4.64568 8.88293 3.21484 10.7813 3.21484H16.3063C17.2554 3.21484 18.5871 3.54068 19.1963 4.14984L21.0096 5.55234C21.7038 6.09068 22.1146 6.91234 22.1146 7.79068Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6196 24.9472H28.0787C30.2746 24.9472 31.1671 24.0972 31.1671 22.0006V7.76307C31.1671 5.66641 30.2746 4.81641 28.0787 4.81641H26.6196C24.4238 4.81641 23.5312 5.66641 23.5312 7.76307V22.0147C23.5312 24.0972 24.4238 24.9472 26.6196 24.9472Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.f7739831df39cafa89c3be54b4a9392c.svg";
export { ForwardRef as ReactComponent };